const transformer = function (origin, defs, rowData, fields, hooks) {
  // const onClick = hooks.showTbDetail
  //   ? () => {
  //       hooks.showTbDetail(rowData)
  //     }
  //   : null

  return {
    render: 'text',
    origin,
    value: origin || rowData.objectId,
    // onClick,
  }
}

export default transformer
